<template>
  <div class="startPage">
    <div class="sp-introduce" v-if="showIntroduce">
      <!-- <span class="sp-i-personIcon"></span> -->
      <img
        src="../../../../assets/icon/classroomObservation/aiImage2.png"
        alt=""
      />
      <div class="sp-i-p-p">
        <div class="sp-i-title">您好，欢迎来到课堂观察</div>
        <div class="sp-i-brief">
          <!-- 基于课堂录音和实录文稿进行分析，为您提供不同启发。 -->
          实时将会议录音转为文字，AI 自动生成会议纪要。
        </div>
      </div>

      <!-- <span class="sp-i-icon1"></span>
			<span class="sp-i-icon2"></span> -->
      <div class="sp-i-btn" @click="showIntroduce = false">我已了解并关闭</div>
    </div>
    <div class="sp-main">
      <div class="sp_m_box">
        <div class="sp_m_b_top">
          <div class="sp_m_b_t_voice">
            <div class="sp_m_b_t_v_title">声纹选择</div>
            <span>请选择/新增本次课堂授课教师的声纹</span>
            <div class="sp_m_b_t_v_inputArea">
              <el-select
                v-model="inputValue"
                @change="handleSelect"
                multiple
                placeholder="请选择"
                :multiple-limit="10"
                filterable
							 :disabled="controlsStatus === 1"
              >
                <el-option
                  v-for="item in teacherList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <span @click="addNew">＋</span>
            </div>
            <img
              src="../../../../assets/icon/classroomObservation/voiceCard.png"
            />
          </div>
        </div>
        <div class="sp_m_b_bottom">
          <div @click.stop="$emit('startTape')">
            <div>开始录音</div>
            <span>实时语音转录文字</span>
            <span>智能课堂观察</span>
            <img
              src="../../../../assets/icon/classroomObservation/startPageIcon2.png"
            />
          </div>
          <div @click.stop="$emit('uploadTape')">
            <div>上传文件</div>
            <span>录音复盘</span>
            <span>一键分析课堂情况</span>
            <img
              src="../../../../assets/icon/classroomObservation/startPageIcon1.png"
            />
          </div>
        </div>
      </div>
      <!-- <div class="sp-m-item" @click.stop="$emit('startTape')">
				<div class="sp-m-item1">开始录音</div>
				<div class="sp-m-item2">
					<p>实时语音转录文字</p>
					<p>智能课堂观察</p>
				</div>
				<div class="sp-m-item3">
					<div style="position: relative;margin-top: 20px;">
						<img
							class="img1"
							src="../../../../assets/icon/classroomObservation/yuan.svg"
							alt=""
						/>
						<img
							class="img2"
							src="../../../../assets/icon/classroomObservation/yuanYin.svg"
							alt=""
						/>
					</div>
				</div>
			</div>
			<div class="sp-m-item" @click.stop="$emit('uploadTape')">
				<div class="sp-m-item1">上传文件</div>
				<div class="sp-m-item2">
					<p>上传录音或实录文稿</p>
					<p>一键分析课堂情况</p>
				</div>
				<div  class="sp-m-item3">
					<img
							class="img1"
							src="../../../../assets/icon/classroomObservation/startPagewen.svg"
							alt=""
						/>
				</div>
			</div> -->
    </div>
  </div>
</template>

<script>
export default {
  emits: ["startTape", "uploadTape"],
  props: {
    teacherVoiceprintList: {
      type: Array,
      default: () => []
    },
    chosenVoiceprint: {
      type: Array,
      default: []
    },
		controlsStatus:{
			type:Number,
			default:0
		},
  },
  data() {
    return {
      showIntroduce: true,
      inputValue: [],
      teacherList: []
    };
  },
  watch: {
    teacherVoiceprintList() {
      this.teacherList = JSON.parse(JSON.stringify(this.teacherVoiceprintList));
    },
    chosenVoiceprint() {
      this.inputValue = this.chosenVoiceprint;
    }
  },
  methods: {
    handleSelect(item) {
      this.$parent.chosenVoiceprint = JSON.parse(JSON.stringify(this.inputValue));
    },
		addNew(){
			this.$parent.onClickAddNewVoiceprint();
		}
  }
};
</script>

<style scoped>
.startPage {
  width: 100%;
  height: calc(100vh - 290px);
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

.sp-introduce {
  width: 100%;
  min-height: 116px;
  height: 116px;
  background-color: #e2eeff;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding-left: 220px;
  padding-top: 20px;
  position: relative;
  margin-top: 7%;
}

.sp-introduce > img {
  width: 200px;
  position: absolute;
  left: 0px;
  bottom: 0;
}

.sp-i-title {
  font-size: 24px;
  font-weight: 600;
  color: #3681fc;
}

.sp-i-p-p {
  position: absolute;
  bottom: 30%;
}

.sp-i-title > span {
  margin: 0 10px;
  white-space: nowrap;
}

.sp-i-brief {
  font-size: 14px;
  margin-top: 10px;
}

.sp-i-personIcon {
  width: 200px;
  /* height: 200px; */
  position: absolute;
  left: 0px;
  bottom: 0;
  background: url("../../../../assets/icon/classroomObservation/aiImage2.png")
    no-repeat;
  background-size: 100% 100%;
  background-position: center 20px;
}

.sp-i-btn {
  width: auto;
  height: auto;
  padding: 5px 10px;
  position: absolute;
  right: 10px;
  bottom: 10px;
  background-color: #3a76fc;
  font-size: 12px;
  border-radius: 20px;
  cursor: pointer;
  color: white;
}

.sp-main {
  width: 80%;
  margin: 10px auto;
  flex: 1;
  display: flex;
  align-items: flex-end;
  /* align-content: center; */
  justify-content: space-around;
  box-sizing: border-box;
  /* padding-bottom: 15%; */
}

.sp_m_box {
  width: 70%;
  height: 100%;
  max-height: 500px;
  /* max-height: 400px; */
  display: flex;
  flex-direction: column;
  margin-bottom: 8%;
}

.sp_m_b_top {
  width: 100%;
  height: 220px;
  /* background-color: red; */
  margin-bottom: 20px;
}

.sp_m_b_bottom {
  width: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sp_m_b_bottom > div {
  height: 100%;
  flex: 1;
  display: flex;
  /* align-items: center; */
  /* justify-content: center; */
  box-sizing: border-box;
  border: 1px solid #aeccfe;
  box-shadow: 0px 4px 10px 0px #1d398314;

  box-shadow: 1px 1px 20px 4px #1d39830d;
  background-color: #fff;
  border-radius: 8px;
  padding: 40px;
  flex-direction: column;
  cursor: pointer;
  position: relative;
}

.sp_m_b_bottom > div > img {
  width: 50%;
  position: absolute;
  right: 0;
  bottom: 0;
}

.sp_m_b_bottom > div > div {
  font-size: 30px;
  font-weight: bold;
  margin-bottom: 10px;
}

.sp_m_b_bottom > div > span {
  margin-top: 5px;
  color: #00000066;
}

.sp_m_b_bottom > div:nth-of-type(2) {
  margin-left: 20px;
}

.sp-m-item {
  width: 220px;
  height: 330px;
  gap: 0px;
  display: flex;
  flex-direction: column;
  border-radius: 8px 0px 0px 0px;
  /* opacity: 0px; */
  background: rgba(224, 234, 251, 1);
  box-sizing: border-box;
  padding: 20px;
  border-radius: 10px;
  cursor: pointer;
}
.sp-m-item1 {
  font-family: PingFang SC;
  font-size: 28px;
  font-weight: 600;
  line-height: 36px;
  text-align: left;
}
.sp-m-item2 {
  margin: 20px 0;
  margin: 0;
}
.sp-m-item2 {
  font-size: 14px;
  font-weight: normal;
  margin: 20px 0;
}
.sp-m-item2 > p {
  margin: 0;
  margin-bottom: 5px;
}
.sp-m-item3 {
  width: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.img1 {
  width: 128px;
  height: 128px;
}
.img2 {
  width: 90px;
  height: 90px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: 0;
  background-color: #5e9afc;
  /* overflow: hidden; */
  border-radius: 50%;
  transform: translate(-50%, -50%);
}

.sp-m-item > span {
  width: 40%;
  height: 40%;
  background-size: 100% 100%;
  margin-bottom: 15px;
}
.sp_m_b_t_voice {
  width: 100%;
  height: 100%;
  display: flex;
  /* align-items: center; */
  /* justify-content: center; */
  box-sizing: border-box;
  border: 1px solid #aeccfe;
  box-shadow: 0px 4px 10px 0px #1d398314;

  box-shadow: 1px 1px 20px 4px #1d39830d;
  background-color: #fff;
  border-radius: 8px;
  padding: 40px;
  flex-direction: column;
  /* cursor: pointer; */
  position: relative;
}

.sp_m_b_t_voice > img {
  height: 80%;
  position: absolute;
  right: 0;
  bottom: 0;
}

.sp_m_b_t_voice > .sp_m_b_t_v_title {
  font-size: 30px;
  font-weight: bold;
  margin-bottom: 10px;
}

.sp_m_b_t_voice > span {
  margin-top: 5px;
  color: #00000066;
}

.sp_m_b_t_v_inputArea {
  margin-top: 10px;
  display: flex;
  align-items: center;
}

.sp_m_b_t_v_inputArea > span {
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f3f7fd;
  border-radius: 3px;
  margin-left: 10px;
  cursor: pointer;
  font-weight: bold;
  color: #3681fc;
  font-size: 16px;
}
/* .sp-m-i-icon1 {
	background: url("../../../../assets/icon/classroomObservation/tape.png")
		no-repeat;
} */

/* .sp-m-i-icon2 {
	background: url("../../../../assets/icon/classroomObservation/file.png")
		no-repeat;
	background-size: 85% 85% !important;
	background-position: center 10px;
} */
</style>



// WEBPACK FOOTER //
// src/components/pages/classroomObservation/components/startPage.vue